module.exports = __webpack_public_path__ + "img/43_50.9e569b46.png";